module.exports = __webpack_public_path__ + "static/img/IMG_20160821_135608.5667b6f1.jpg";